import {useEffect, useState, type RefObject} from 'react'

/**
 * Custom hook to determine if a tooltip should be shown for truncated file names.
 * This hook checks whenever the element is hovered for whether it is large enough to require a tooltip.
 */
export function useFileNameTooltip(headingRef: RefObject<HTMLElement>) {
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const heading = headingRef.current
    if (!heading) return
    const showIfOverflowing = () => {
      setIsOverflowing(heading.scrollWidth > heading.offsetWidth)
    }

    heading.onfocus = () => {
      showIfOverflowing()
    }
    heading.onblur = () => {
      setIsOverflowing(false)
    }
    heading.onmouseenter = () => {
      showIfOverflowing()
    }
    heading.onmouseleave = () => {
      setIsOverflowing(false)
    }
  }, [headingRef])

  return isOverflowing
}
